/* eslint-disable no-console */
/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import _uniqueId from 'lodash/uniqueId';
import { AnyAction, Reducer } from 'redux';
import { put, takeLatest } from 'redux-saga/effects';

import { MOBILE_OFFSET, ONE_MINUTE_MILLIS } from '@constants';
import { ICurrency } from '@interface/currency';
import { INotification } from '@interface/notification';
import { ISagaEvent } from '@interface/saga-event';
import {
  GetCurrencies,
  GetFiatCurrency,
  GetUserBoards,
  GetUserNotifications,
  GetUserUnsignCollaborations,
} from '@lib/versum';
import { customFloor } from '@utils/math';

export interface IGlobal {
  ready: boolean;
  tezos: number;
  sessionnotifications: INotification[];
  systemnotifications: INotification[];
  notifications: INotification[];
  boards: any[];
  collaborations: any[];
  mobileOffset: MOBILE_OFFSET;
  currencies: ICurrency[];
}

export const initialState: IGlobal = {
  ready: false,
  tezos: 0, // tezos value on user selected fiat
  sessionnotifications: [], // in session notifications
  systemnotifications: [], // system notifications
  notifications: [], // both session and system notifications ordered by timestamp;
  boards: [], // user boards
  collaborations: [], // user collaborations
  mobileOffset: MOBILE_OFFSET.CENTER,
  currencies: [], // whitelisted currencies for marketplace
};

export enum actions {
  GLOBAL_READY = 'GLOBAL_READY',
  GLOBAL_GET_TEZOS = 'GLOBAL_GET_TEZOS',
  GLOBAL_SET_TEZOS = 'GLOBAL_SET_TEZOS',
  GLOBAL_ADD_SESSION_NOTIFICATION = 'GLOBAL_ADD_SESSION_NOTIFICATION',
  GLOBAL_USER_VIEWS_NOTIFICATION = 'GLOBAL_USER_VIEWS_NOTIFICATION',
  GLOBAL_GET_SYSTEM_NOTIFICATIONS = 'GLOBAL_GET_SYSTEM_NOTIFICATIONS',
  GLOBAL_UPDATE_SYSTEM_NOTIFICATIONS = 'GLOBAL_UPDATE_SYSTEM_NOTIFICATIONS',
  GLOBAL_GET_BOARDS = 'GLOBAL_GET_BOARDS',
  GLOBAL_UPDATE_BOARDS = 'GLOBAL_UPDATE_BOARDS',
  GLOBAL_GET_COLLABORATIONS = 'GLOBAL_GET_COLLABORATIONS',
  GLOBAL_UPDATE_COLLABORATIONS = 'GLOBAL_UPDATE_COLLABORATIONS',
  GLOBAL_MOBILE_OFFSET = 'GLOBAL_MOBILE_OFFSET', // -1 left 0 center 1 right
  GLOBAL_GET_CURRENCIES = 'GLOBAL_GET_CURRENCIES',
  GLOBAL_SET_CURRENCIES = 'GLOBAL_SET_CURRENCIES',
}

export const reducer: Reducer<IGlobal, AnyAction> = (state = initialState, action) => {
  switch (action.type) {
    case actions.GLOBAL_READY:
      return { ...state, ready: action.payload };
    case actions.GLOBAL_SET_TEZOS:
      return { ...state, tezos: action.payload };
    case actions.GLOBAL_USER_VIEWS_NOTIFICATION:
      const nextSessionNotifications = state.sessionnotifications.map((content) => {
        if (content.notificationid === action.payload) {
          return { ...content, viewed: true };
        }
        return content;
      });

      const nextSystemNotifications = state.systemnotifications.map((content) => {
        if (content.notificationid === action.payload) {
          return { ...content, viewed: true };
        }
        return content;
      });

      return {
        ...state,
        sessionnotifications: nextSessionNotifications,
        systemnotifications: nextSystemNotifications,
        notifications: nextSystemNotifications
          .concat(nextSessionNotifications)
          .sort((a, b) => b.timestamp - a.timestamp),
      };
    case actions.GLOBAL_ADD_SESSION_NOTIFICATION:
      const newNotification = { ...action.payload, notificationid: _uniqueId('sn-') };
      const sessionnotifications = [...state.sessionnotifications, newNotification];

      return {
        ...state,
        sessionnotifications,
        notifications: sessionnotifications
          .concat(state.systemnotifications)
          .sort((a: INotification, b: INotification) => b.timestamp - a.timestamp),
      };
    case actions.GLOBAL_UPDATE_SYSTEM_NOTIFICATIONS:
      const systemnotifications = action.payload;
      return {
        ...state,
        systemnotifications,
        notifications: systemnotifications
          .concat(state.sessionnotifications)
          .sort((a: INotification, b: INotification) => b.timestamp - a.timestamp),
      };
    case actions.GLOBAL_UPDATE_BOARDS:
      return { ...state, boards: action.payload };
    case actions.GLOBAL_UPDATE_COLLABORATIONS:
      return { ...state, collaborations: action.payload };
    case actions.GLOBAL_MOBILE_OFFSET:
      return { ...state, mobileOffset: action.payload };
    case actions.GLOBAL_SET_CURRENCIES:
      return { ...state, currencies: action.payload };
    default:
      return state;
  }
};

function* updateTezosValue(event: ISagaEvent) {
  try {
    const { tezos } = yield GetFiatCurrency(event.payload);
    yield put({ type: actions.GLOBAL_SET_TEZOS, payload: tezos[event.payload] });
  } catch (error) {
    console.log('error coingeko api', error);
  }
}

function* updateBoards(event: ISagaEvent) {
  const { token_lists } = yield GetUserBoards(event.payload.id);
  yield put({ type: actions.GLOBAL_UPDATE_BOARDS, payload: token_lists });
}

function* updateCollaborations(event: ISagaEvent) {
  const startTime = customFloor(Date.now(), ONE_MINUTE_MILLIS);
  const { tokens } = yield GetUserUnsignCollaborations(event.payload.id, startTime);
  yield put({ type: actions.GLOBAL_UPDATE_COLLABORATIONS, payload: tokens });
}

function* updateNotifications(event: ISagaEvent) {
  const { notifications } = yield GetUserNotifications(event.payload.id);
  yield put({ type: actions.GLOBAL_UPDATE_SYSTEM_NOTIFICATIONS, payload: notifications });
}

function* updateCurrencies(/* event:ISagaEvent */) {
  const { currencies } = yield GetCurrencies();
  yield put({ type: actions.GLOBAL_SET_CURRENCIES, payload: currencies });
}

export function* saga() {
  yield takeLatest(actions.GLOBAL_GET_TEZOS, updateTezosValue);
  yield takeLatest(actions.GLOBAL_GET_BOARDS, updateBoards);
  yield takeLatest(actions.GLOBAL_GET_COLLABORATIONS, updateCollaborations);
  yield takeLatest(actions.GLOBAL_GET_SYSTEM_NOTIFICATIONS, updateNotifications);
  yield takeLatest(actions.GLOBAL_GET_CURRENCIES, updateCurrencies);
}
